import type { TokenData } from "@/types/GlobalState";
export type { TokenData } from "@/types/GlobalState";

let inMemoryToken: TokenData | null = null;

/**
 * Synchronously read the current token from memory
 */
export const getToken = (): string => inMemoryToken?.token || publicInMemoryToken?.token || "";

/**
 * Synchronously read the full token data
 */
export const getTokenData = (): TokenData | null => inMemoryToken;

/**
 * Update the in-memory token
 */
export const setTokenData = (data: TokenData | null): void => {
    inMemoryToken = data;
};

/**
 * Clear the token
 */
export const clearToken = (): void => {
    inMemoryToken = null;
};

// ─── Public User Token (isolated from authenticated session token) ─────────────

let publicInMemoryToken: TokenData | null = null;

/**
 * Synchronously read the full public-user token data.
 * Kept separate from inMemoryToken to avoid overwriting authenticated sessions.
 */
export const getPublicTokenData = (): TokenData | null => publicInMemoryToken;

/**
 * Update the in-memory public-user token
 */
export const setPublicTokenData = (data: TokenData | null): void => {
    publicInMemoryToken = data;
};

/**
 * Clear the public-user token
 */
export const clearPublicToken = (): void => {
    publicInMemoryToken = null;
};
